import * as React from 'react';

import backgroundPrimary from '../../assets/images/backgroundPrimary.png'
import { makeStyles, Theme } from '@material-ui/core/styles';
import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
import Alert from '@material-ui/lab/Alert';

import { Button, Card, Link, Fade } from '@material-ui/core';
import loginLogo from '../../assets/images/loginLogo.png'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../shared/theme';
import { useHistory } from "react-router-dom";
import '../../style/SignUpVerifyEmailStylesheet.css'
import api from '../../store/api';
import { useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundImage: `url(${backgroundPrimary})`,
        backgroundBlendMode: 'overlay',
        backgroundColor: 'rgba(0, 21, 46, 0.6)',
        boxShadow: 'none',
        width: '100%',
        height: '100%',
        position: 'fixed',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingTop: 80,
        paddingLeft: 40
    },
    container: {
        width: 461,
        background: theme.palette.primary.main,
        borderRadius: 0,
    },

    inputs: {
        marginTop: 10,
        marginLeft: 40,
        marginRight: 40,
    },
    button: {
        width: '100%',
        padding: 9,
        borderRadius: 5,
        background: 'white',
        color: theme.palette.primary.main,
        marginBottom: 40,
        fontSize: 'medium',
    },

    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: '30px',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 150
    },

    signUpHeading: {
        fontFamily: 'lato',
        fontSize: 28,
        margin: 10,
        color: '#fff',
        fontWeight: 'bold',
        lineHeight: 'normal',
    },
    heading: {
        marginLeft: 40,
    },
    form: {
        marginBottom: 40,
    },
    confirmContainer: {
        backgroundColor: "#001530",
        textAlign: "center",
        color: "#fff",
        padding: '30px 40px'
    },
    textFieldInput: {
        backgroundColor: 'rgba(255,255,255, 0.25)',
        color: '#fff',
        borderRadius: '5px',
    },
    textFieldRoot: {
        width: '100%',
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '5px',
    },
    mailIcon: {
        fontSize: 48
    },
    otherInstructions: {
        marginTop: 30,
        marginBottom: 30,
        marginLeft: 40,
        marginRight: 40,
        color: 'rgba(255,255,255, 0.61)',
        textAlign: "center"
    },
    link: {
        color: '#F5F5F5',
        paddingLeft: 0,

    },
    alertSuccessRoot: {
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 30
    },
}));
export interface IResetPasswordSubmittedProps {
    emailAddress: string
}

function ResetPasswordSubmitted(props: IResetPasswordSubmittedProps) {
    const classes = useStyles();
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false)



    //call to reset password => update password
    const resetPassword = async (event: React.MouseEvent<HTMLAnchorElement>): Promise<void> => {
        event.preventDefault();
        if (!sendingEmail) {
            setShowSuccess(false);
            setSendingEmail(true);
            const _req: { [index: string]: string } = {
                emailAddress: props.emailAddress,
            };

            await api.generateResetPasswordRequest('', _req);
            setSendingEmail(false);
            setShowSuccess(true);
        }
    }
    const backToLogin = () => {
        history.push('/login');
    }

    return (
        <div className={classes.root}>
            <React.Fragment>

                <Card className={classes.container}>
                    <div className={classes.logoRoot}>
                        <img src={loginLogo} className={classes.logoImg} alt="logo" />
                    </div>

                    <div className={classes.confirmContainer}>
                        <MailOutlineOutlinedIcon className={classes.mailIcon} />
                        <h2 className={classes.signUpHeading}>Check Your Email</h2>
                            We've just sent instructions for resetting your password to {props.emailAddress}.
                        </div>

                    <div className={classes.otherInstructions}>
                        Didn’t get the email?<br />
Wait a few minutes and remember to check your spam folder. You can also <Link href="#" className={classes.link} style={{pointerEvents: sendingEmail ? "none" : "auto"}} onClick={resetPassword}>
                            send the email again.
  </Link>

                    </div>

                    <Alert variant="filled" severity="success" classes={{ root: classes.alertSuccessRoot }} style={{ display: showSuccess ? 'flex' : 'none' }}>
                        Instructions has been sent to your email address.
                        </Alert>

                    <div className={classes.inputs}>
                        <Button
                            className={classes.button}
                            variant="contained" onClick={backToLogin}>Back to sign in</Button>
                    </div>
                </Card>

            </React.Fragment >
        </div>
    );
}

export default ResetPasswordSubmitted